import React from 'react';
import { Button } from '@mui/material';

interface DiscussionsButtonProps {
  url: string;
  label?: string;
  style?: React.CSSProperties;
}

const DiscussionsButton: React.FC<DiscussionsButtonProps> = ({ url, label = 'Обсуждение', style }) => {
  return (
    <Button
      variant="outlined" // You can change this to "text" if needed
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ marginTop: '10px', color: '#1976d2', borderColor: '#1976d2', ...style }} // You can override styles
    >
      {label}
    </Button>
  );
};

export default DiscussionsButton;
